// src/icons/OuraRing4Logo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function OuraRing4Logo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 28,
    viewBox: "0 0 134 28",
    width: 134,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("mask", {
        height: 27,
        id: "oura_ring_4_logo_mask_0",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance"
        },
        width: 134,
        x: 0,
        y: 0,
        children: /* @__PURE__ */ jsx("path", {
          d: "M133.811 0H0.173828V26.8656H133.811V0Z",
          fill: "white"
        })
      }),
      /* @__PURE__ */ jsxs("g", {
        mask: "url(#oura_ring_4_logo_mask_0)",
        children: [
          /* @__PURE__ */ jsx("path", {
            d: "M2.40741 19.4794C0.586181 17.5765 0.173828 15.2584 0.173828 12.3867C0.173828 9.51508 0.586181 7.197 2.40741 5.2941C3.7132 3.91016 5.46569 3.18359 7.49309 3.18359C9.5205 3.18359 11.273 3.91016 12.5788 5.2941C14.4 7.197 14.8124 9.51508 14.8124 12.3867C14.8124 15.2584 14.4 17.5765 12.5788 19.4794C11.273 20.8633 9.5205 21.5554 7.49309 21.5554C5.46569 21.5554 3.7132 20.8633 2.40741 19.4794ZM11.1012 17.9225C12.4413 16.4347 12.5444 14.3588 12.5444 12.3521C12.5444 10.3454 12.407 8.30414 11.1012 6.78181C10.2078 5.81306 9.03942 5.2595 7.52747 5.2595C6.0155 5.2595 4.8128 5.81306 3.95374 6.78181C2.61359 8.26955 2.5105 10.3454 2.5105 12.3521C2.5105 14.3588 2.64795 16.4001 3.95374 17.9225C4.84716 18.8912 6.04986 19.4102 7.52747 19.4102C9.00506 19.4102 10.2421 18.8912 11.1012 17.9225Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M16.8398 16.9188V8.61523H18.936V16.6074C18.936 18.4757 19.795 19.6175 21.6162 19.6175C23.4375 19.6175 24.8463 17.8876 24.8463 15.3965V8.61523H26.9426V21.209H25.1213L24.9838 19.1677C24.4684 20.7246 22.7847 21.5549 21.3069 21.5549C18.5924 21.5549 16.8398 19.7905 16.8398 16.9188Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M29.2446 8.61552H31.1345L31.3062 10.7952C31.9593 9.16908 33.4711 8.51172 35.0518 8.51172C36.6326 8.51172 35.7047 8.51172 36.0485 8.5809V10.6914C35.7735 10.6222 35.4642 10.553 35.0518 10.553C32.3029 10.553 31.375 12.6289 31.375 15.0508V21.1402H29.2789V8.61552H29.2446Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M36.9414 17.6455C36.9414 16.0194 37.9723 13.8743 41.4086 13.6667L45.223 13.4245V12.5596C45.223 10.7605 44.2951 9.9301 42.5083 9.9301C40.7215 9.9301 39.6561 10.7951 39.6561 12.2136H37.5945C37.6287 9.65332 39.7936 8.2002 42.5083 8.2002C45.223 8.2002 47.3191 9.75712 47.3191 12.5596V18.6489C47.3191 19.3062 47.5939 19.5138 48.0064 19.5138C48.4187 19.5138 48.35 19.5138 48.556 19.4446V21.0016C48.1094 21.2437 47.6971 21.313 47.1816 21.313C46.0821 21.313 45.3605 20.448 45.3605 19.41C44.6044 20.621 43.0924 21.4859 41.3056 21.4859C38.4534 21.4859 37.0102 19.5484 37.0102 17.6109L36.9414 17.6455ZM45.1885 15.881V15.1198L41.5804 15.3274C40.3434 15.3966 39.072 16.0886 39.072 17.6109C39.072 19.1332 39.7593 19.7906 41.5461 19.7906C43.3329 19.7906 45.1885 18.0607 45.1885 15.881Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M120.649 0C113.364 0 107.488 5.91629 107.488 13.2511C107.488 20.5859 113.364 26.5022 120.649 26.5022C127.934 26.5022 133.81 20.5514 133.81 13.2511C133.81 5.9509 127.934 0 120.649 0ZM126.663 18.1641H124.223V21.8662H122.092V18.1641H113.708V15.8114L120.581 4.60158H122.917L115.701 16.2266H122.092V11.1406H124.223V16.2266H126.663V18.1295V18.1641Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M63.0752 3.49121C66.6351 3.49121 68.91 5.43216 68.91 8.64288C68.91 10.8849 67.6248 12.7013 65.1783 13.4209L68.9375 21.1364H66.4669L62.955 13.7946H58.4054V21.1364H56.2061V3.49121H63.0787H63.0752ZM66.6351 8.64288C66.6351 6.40093 65.1508 5.53251 63.0752 5.53251H58.4019V11.7291H63.0752C65.1508 11.7291 66.6351 10.8814 66.6351 8.64288Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M73.2631 3.16943V5.65704H70.8164V3.16943H73.2631ZM73.1118 8.57021V21.1398H70.9607V8.57021H73.1118Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M75.7344 8.57016H77.5624L77.7342 10.5111C78.3768 9.01647 80.1809 8.2207 81.5897 8.2207C84.4316 8.2207 85.9917 9.93678 85.9917 12.85V21.1398H83.8885V13.151C83.8885 11.3103 83.0467 10.1375 81.1945 10.1375C79.0916 10.1375 77.8305 11.9781 77.8305 14.3204V21.1398H75.7275V8.57016H75.7344Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M87.627 23.2052C87.627 21.887 88.4929 20.9632 89.5067 20.5169C88.7402 20.1675 88.2214 19.472 88.2214 18.4998C88.2214 17.3788 89.0873 16.4828 89.9774 16.0849C89.0392 15.3894 88.4206 14.0194 88.4206 12.7738C88.4206 9.98521 90.5237 8.21724 93.3654 8.21724C94.551 8.21724 95.5166 8.49055 96.2829 8.96455C96.7022 7.84357 97.6677 7.17236 98.8532 7.17236C99.0766 7.17236 99.2965 7.19658 99.4718 7.2208V8.96455C99.324 8.94033 99.1763 8.94033 99.0011 8.94033C98.1865 8.94033 97.5921 9.38664 97.4684 10.0855C97.9873 10.7567 98.2827 11.5802 98.2827 12.6977C98.2827 15.386 96.2073 17.2024 93.3621 17.2024C92.5476 17.2024 91.8055 17.0779 91.1628 16.8045C90.6439 16.9533 90.1251 17.4999 90.1251 18.0743C90.1251 18.9219 90.8434 19.1434 91.6335 19.1434H94.3517C95.8363 19.1434 97.5407 19.4167 98.5303 20.4373C99.1247 21.0359 99.5199 21.8558 99.5199 22.9007C99.5199 25.814 96.6025 26.8588 93.3654 26.8588C90.1286 26.8588 87.6303 25.8624 87.6303 23.1984L87.627 23.2052ZM97.4649 22.9075C97.4649 21.0393 95.6093 20.9424 94.1044 20.9424H91.2109C90.2729 21.1916 89.5787 21.9388 89.5787 22.9075C89.5787 24.8245 91.6302 25.0735 93.4858 25.0735C95.3413 25.0735 97.4649 24.6999 97.4649 22.9075ZM96.2519 12.7012C96.2519 11.1096 95.1902 9.93677 93.3586 9.93677C91.5272 9.93677 90.4653 11.1062 90.4653 12.7012C90.4653 14.2961 91.5272 15.514 93.3586 15.514C95.1902 15.514 96.2519 14.2927 96.2519 12.7012Z",
            fill: "currentColor"
          })
        ]
      })
    ]
  });
}
export {
  OuraRing4Logo
};
//# sourceMappingURL=OuraRing4Logo.mjs.map